var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[(_vm.white)?_c('v-chip',{staticClass:"white--text",attrs:{"label":"","color":"rgba(60,60,59,0.5)"}},[_vm._v(" "+_vm._s(_vm.text)+" ")]):_vm._e(),(!_vm.white)?_c('v-chip',{staticClass:"white--text",attrs:{"label":"","color":"rgba(60,60,59,0.5)"}},[_vm._v(" "+_vm._s(_vm.text)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }